import z from 'zod';
import { territorialIdSchema } from './paramTypeSchema.js';
import { timestampSchema } from './commonSchemas.js';
import { profileAdditionalDataSchemaItem, profileAdditionalDataSchemaRecord } from './profileAdditionalDataSchema.js';
// Schema per i valori concreti degli attributi nei profili
export const profileAttributeValueSchema = z.union([
    z.number(),
    // z.string(),
    z.boolean(),
    z.date(),
    z.string().datetime().transform((str) => new Date(str)), // ISO datetime strings
    z.string().regex(/^\d{4}-\d{2}-\d{2}$/).transform((str) => new Date(str)) // YYYY-MM-DD format
    // z.array(z.string()),
    // z.array(z.number())
]);
// Schema per ProfileAttribute
export const profileAttributeSchema = z.object({
    attribute_id: z.number(),
    value: profileAttributeValueSchema
});
// Schema più tollerante per UI che accetta anche date come stringhe
export const profileAttributeSchemaUI = z.object({
    attribute_id: z.number(),
    value: z.union([
        z.number(),
        z.boolean(),
        z.date(),
        z.string().datetime().transform((str) => new Date(str)), // ISO datetime strings
        z.string().regex(/^\d{4}-\d{2}-\d{2}$/).transform((str) => new Date(str)) // YYYY-MM-DD format
    ])
});
/**
 * Schema per ProfileDefRow
 * @db_table profiles
 */
export const profileDefRowSchema = z.object({
    id: z.number().describe('type:number,editable:false,label:ID'),
    first_name: z.string().describe('label:Nome'),
    last_name: z.string().describe('label:Cognome'),
    cod_fiscale: z.string().optional().nullable().describe('label:Codice Fiscale'),
    iscritto: z.boolean().optional().nullable().describe('label:Iscritto,type:boolean'),
    email: z.string().optional().nullable().describe('label:Email'),
    phone: z.string().optional().nullable().describe('label:Telefono'),
    //organizations è un'array di organization_id 
    // perché ogni organizzazione che edita il profilo viene registrata
    // in modo da poter tenere traccia di chi ha modificato il profilo  
    // ma il profilo resta unico
    organizations: z.array(z.number()).optional().nullable().describe('type:organizations,label:Organizzazioni'),
    residenza: territorialIdSchema.nullable().describe('type:comune,label:Residenza'), // es: "1-03-017-017001" per Milano
    attribute_values: z.array(profileAttributeSchema).optional().nullable().describe('type:profiles-attributes,label:Attributi'),
    additional_data: z.array(profileAdditionalDataSchemaRecord).optional().nullable().describe('type:profiles-additional,label:Dati Aggiuntivi'),
    created_at: timestampSchema.describe('type:datetime,editable:false,label:Data Creazione'),
    updated_at: timestampSchema.describe('type:datetime,editable:false,label:Data Modifica')
});
export const profileDefRowSchemaNoId = profileDefRowSchema.omit({ id: true, created_at: true, updated_at: true });
/**
 * Schema per ProfileDefRowView
 * @db_view profiles_list_view
 */
export const profileDefRowSchemaView = profileDefRowSchema.extend({
    full_name: z.string().nullable(),
    territorial_info: z.any().optional().nullable(), // JSON delle informazioni territoriali
    organizations_info: z.any().optional().nullable(), // JSON array delle organizzazioni
    attributes_count: z.number().nullable(),
    additional_data_count: z.number().nullable(),
    organizations_count: z.number().optional().nullable(),
    cod_fiscale_info: z.any().optional().nullable(), // JSON completo del codice fiscale
    age: z.number().optional().nullable(),
    data_nascita: z.string().optional().nullable(),
    luogo_nascita: z.string().optional().nullable(),
    gender: z.string().optional().nullable(),
    cod_fiscale_valid: z.boolean().optional().nullable()
});
//# sourceMappingURL=profileDefSchema.js.map